import * as React from "react"
import { IconProps } from "./utils"

export function CosmicJsIcon({
  height = 20,
  width = 20,
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.81517 8.9971C10.3006 8.58634 10.7487 8.17557 11.2342 7.80215C10.8607 7.54076 10.5247 7.3167 10.1886 7.09265C9.77783 7.42873 9.36706 7.80215 8.9563 8.17557C9.36706 8.32494 9.6658 8.62368 9.81517 8.9971Z"
        fill="#29ABE2"
      />
      <path
        d="M8.61607 10.864C9.50288 10.8664 10.2236 10.1828 10.2258 9.33723C10.228 8.49166 9.51096 7.8043 8.62414 7.80196C7.73733 7.79963 7.01662 8.48319 7.01439 9.32876C7.01216 10.1743 7.72926 10.8617 8.61607 10.864Z"
        fill="#29ABE2"
      />
      <path
        d="M10.0765 17.9218C7.87335 19.1168 5.9689 19.4155 5.11003 18.594C3.91508 17.4364 4.99801 14.4117 7.61196 11.3496C7.20119 11.2376 6.86511 10.9389 6.6784 10.5654C2.8695 14.8224 1.15177 19.1168 2.83216 20.7225C4.21382 22.0668 7.53727 21.1706 11.1968 18.7807C10.8234 18.5193 10.45 18.2206 10.0765 17.9218Z"
        fill="#29ABE2"
      />
      <path
        d="M12.6896 7.72743C12.8017 7.31667 13.1004 6.98059 13.4738 6.79388C9.06746 3.17169 4.5864 1.56598 2.906 3.17169C1.52434 4.51601 2.42055 7.69009 4.92248 11.2002C5.22121 10.8268 5.51995 10.4907 5.81869 10.1173C4.5864 7.98883 4.25032 6.15906 5.10919 5.30019C6.34148 4.14259 9.47822 5.22551 12.6896 7.72743Z"
        fill="#29ABE2"
      />
      <path
        d="M15.6778 8.77295C15.5285 9.14637 15.1924 9.44511 14.819 9.59448C15.3791 10.1546 15.9019 10.6774 16.35 11.2375C16.6114 10.9015 16.8728 10.5654 17.0595 10.2293C16.6487 9.74385 16.1633 9.2584 15.6778 8.77295Z"
        fill="#29ABE2"
      />
      <path
        d="M14.7816 10.2666C15.6778 10.2666 16.3873 9.59448 16.3873 8.73562C16.3873 7.87675 15.6778 7.20459 14.7816 7.20459C13.8854 7.20459 13.1759 7.87675 13.1759 8.73562C13.1759 9.55714 13.8854 10.2666 14.7816 10.2666Z"
        fill="#29ABE2"
      />
      <path
        d="M18.9265 5.33751C20.1214 6.49512 19.0385 9.51983 16.4246 12.5819C16.8353 12.6939 17.1714 12.9926 17.3581 13.3661C21.1297 9.10907 22.8474 4.77738 21.167 3.17167C19.7854 1.86469 16.4619 2.7609 12.8397 5.1508C13.2131 5.41219 13.5866 5.71093 13.96 6.00967C16.1632 4.81472 18.0676 4.51598 18.9265 5.33751Z"
        fill="#29ABE2"
      />
      <path
        d="M14.4829 14.673C13.9227 15.1958 13.3253 15.6812 12.7651 16.1293C13.1386 16.3907 13.4746 16.6148 13.8481 16.8388C14.3708 16.4281 14.8563 15.9799 15.3791 15.4945C14.9683 15.3451 14.6696 15.0464 14.4829 14.673Z"
        fill="#29ABE2"
      />
      <path
        d="M15.402 13.0868C14.5152 13.0844 13.7944 13.7679 13.7921 14.6134C13.7897 15.459 14.5067 16.1465 15.3936 16.1489C16.2804 16.1513 17.0012 15.4679 17.0035 14.6223C17.0058 13.7767 16.2888 13.0893 15.402 13.0868Z"
        fill="#29ABE2"
      />
      <path
        d="M9.21757 14.3743C8.65744 13.8141 8.13465 13.2913 7.68655 12.7312C7.42516 13.0673 7.16376 13.4034 6.97705 13.7394C7.42516 14.2249 7.87326 14.7103 8.35871 15.1958C8.50807 14.8224 8.80681 14.5236 9.21757 14.3743Z"
        fill="#29ABE2"
      />
      <path
        d="M19.1132 12.7686C18.8145 13.142 18.5158 13.4781 18.217 13.8515C19.4493 15.98 19.7854 17.7724 18.8892 18.6313C17.6569 19.7889 14.5201 18.706 11.3087 16.2414C11.1967 16.6521 10.898 16.9882 10.5245 17.1749C14.9683 20.7971 19.4493 22.4402 21.1297 20.8345C22.5114 19.4528 21.6152 16.2414 19.1132 12.7686Z"
        fill="#29ABE2"
      />
      <path
        d="M10.8677 15.2159C10.8699 14.3704 10.1528 13.683 9.26597 13.6807C8.37915 13.6784 7.65846 14.3619 7.65624 15.2075C7.65402 16.0531 8.37112 16.7404 9.25793 16.7427C10.1447 16.7451 10.8654 16.0615 10.8677 15.2159Z"
        fill="#29ABE2"
      />
    </svg>
  )
}
